import { init, setUser } from '@sentry/react';

const DSN = import.meta.env.VITE_SENTRY_DSN;
// eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing -- `||` also falls back when the variable is set but empty; `??` would not
const ENV = import.meta.env.VITE_NODE_ENV || import.meta.env.NODE_ENV;

export const initErrorTracking = () => {
  if (ENV !== 'development') {
    init({
      dsn: DSN,
      environment: ENV,
    });
  }
};

export const setAdminUserForErrorTracking = ({
  email,
  id,
}: {
  email?: string;
  id?: string;
}) => {
  setUser({ email, id });
};
